import styled from 'styled-components';
import PropTypes from 'prop-types';
import { COMMON, LAYOUT } from '../constants';
import { fill, stroke } from '../Icon/utils/styledSystemProps';
const Svg = styled.svg.attrs(p => ({
  fill: p.fill,
  strokeWidth: p.strokeWidth,
  strokeLinecap: p.strokeLinecap,
  strokeLinejoin: p.strokeLinejoin,
  viewBox: p.viewBox
})).withConfig({
  displayName: "Svg",
  componentId: "nviel0-0"
})(["max-width:100%;height:auto;", ";", ";", " ", ""], stroke, fill, COMMON, LAYOUT);
Svg.defaultProps = {
  stroke: 'currentColor',
  fill: 'none'
};
Svg.propTypes = { ...COMMON.propTypes,
  ...LAYOUT.propTypes,

  /** Presentation attribute defining the color (or any SVG paint servers like gradients or patterns) used to paint the outline of the shape */
  stroke: PropTypes.string,

  /** Fill of the Icon */
  fill: PropTypes.string,

  /** Presentation attribute defining the width of the stroke to be applied to the shape. */
  strokeWidth: PropTypes.string,

  /** Presentation attribute defining the shape to be used at the end of open subpaths when they are stroked. */
  strokeLinecap: PropTypes.string,

  /** Presentation attribute defining the shape to be used at the corners of paths when they are stroked. */
  strokeLinejoin: PropTypes.string,

  /** defines the position and dimension, in user space, of an SVG viewport. */
  viewBox: PropTypes.string
};
Svg.displayName = 'Svg';
export default Svg;